import React, { useState,useRef, useEffect, useContext, useCallback, useMemo, Suspense } from 'react';
import { RefreshContext } from "../RefreshContext";
import CompanyAPI from '../restAPI/CompanyAPI';
import { Layout, Menu, Switch, theme, Typography, Avatar, Dropdown, Badge, Button, Drawer, message, Space, Input, Flex, Tour, Card, Spin } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { logout } from '../redux/slices/authSlice';
import {
  HomeOutlined,
  AppstoreOutlined,
  FileWordOutlined,
  CalendarOutlined,
  MessageOutlined,
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
  MoonOutlined,
  BellOutlined,
  MenuOutlined,
  SunOutlined,
  BankOutlined,
  ExportOutlined,
  QuestionCircleOutlined,
  ReadOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import Logo from '../assets/logo/logo.svg';
import CompanyLogo from '../assets/logo/companylogo.png';
import AuthRestAPI from '../restAPI/AuthRestAPI';
import { persistAllowCompanyCreationForGroup } from '../utils/companyGroupAdmin';
import { decodeToken } from "react-jwt";
import UserAPI from '../restAPI/UserAPI';
import {
  getCompanySubscriptionStatus,
  shouldPollSubscriptionState,
  shouldShowSelfOnboardingPortalLink,
} from '../utils/subscriptionPlan';
import { openManageProfileLink } from '../utils/openManageProfileLink';
import useSubscriptionQuotaRefresh from '../hooks/useSubscriptionQuotaRefresh';
import {
  isSubscriptionPlanFeatureEnabled,
  SUBSCRIPTION_FEATURE_KEYS,
  SUBSCRIPTION_MASTER_DATA_DISABLED_HINT,
} from '../utils/subscriptionPlanFeatures';
import SubscriptionExpiredBanner from '../components/SubscriptionExpiredBanner';
import SubscriptionExpiringSoonBanner from '../components/SubscriptionExpiringSoonBanner';
import SubscriptionExpiredLogoutModal from '../components/SubscriptionExpiredLogoutModal';
import LogoutConfirmModal from '../components/LogoutConfirmModal';
import useSubscriptionExpiryWatcher from '../hooks/useSubscriptionExpiryWatcher';
import SubscriptionRestrictionTooltip from '../components/SubscriptionRestrictionFeedback';
import ContextSelector from './ContextSelector';
import FeatureNewsHost, {
  FeatureNewsAdminModal,
  isFeatureNewsEnabled,
} from '../features/featureNews';
import { FaqAdminModal, FaqDrawer, isFaqEnabled } from '../features/faq';


const { Header, Footer, Content } = Layout;
const { Title } = Typography;



const items = [
  {
    label: 'Organization 1',
    key: '1',
    icon: <UserOutlined />,
  },
  {
    label: 'Organization 2',
    key: '2',
    icon: <UserOutlined />,
  },
];

const menuProps = {
  items,
};

function getItem(label, key, icon, children, type, isDisabeld = false) {
  return {
    key,
    icon,
    children,
    label,
    type,
    disabled : isDisabeld 
  };
}

/** Wraps disabled menu labels so Tooltip still works on hover. */
function getDisabledTooltipLabel(text, disabled, tooltipTitle, tooltipHeading = 'Not available') {
  if (!disabled) {
    return text;
  }

  return (
    <SubscriptionRestrictionTooltip
      title={tooltipHeading}
      message={tooltipTitle}
      variant="warning"
      placement="bottom"
      compact
      showPortalLink={false}
    >
      <span
        style={{
          display: 'inline-block',
          width: '100%',
          cursor: 'not-allowed',
        }}
      >
        {text}
      </span>
    </SubscriptionRestrictionTooltip>
  );
}

export default function MainLayout({ isDarkMode, toggleTheme, children }) {
const { token, userId: authUserId } = useSelector(state => state.auth);
//const { refreshKey, companyLogo, setCompanyLogo } = useContext(RefreshContext);
const [open, setOpen] = useState(false);
const ref1 = useRef(null);
const ref2 = useRef(null);
const [radius, setRadius] = useState(8);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
  const [featureNewsAdminOpen, setFeatureNewsAdminOpen] = useState(false);
  const [faqAdminOpen, setFaqAdminOpen] = useState(false);
  const [faqDrawerOpen, setFaqDrawerOpen] = useState(false);
  const navigate = useNavigate();
 // const { token } = useSelector(state => state.auth);
  const [groupId, setGroupId] = useState("Select Group");
  const [companyId, setCompanyId] = useState("Select Company");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupsData, setGroupsData] = useState([]);
  const [companys, setCompanys] = useState([]);

  const [iSGetGroups, setISGetGroups] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [helpLoading, setHelpLoading] = useState(false);
  const [manageProfileLoading, setManageProfileLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState();
  const [menuItems, setMenuItems] = useState([]);
  const {
    refreshKey,
    applySubscriptionState,
    clearSubscriptionState,
    setSystemAdminSubscriptionAccess,
    registerSubscriptionReload,
    refreshSubscriptionState,
    subscriptionReadOnly,
    subscriptionPlanExpired,
    subscriptionExpiringSoon,
    subscriptionDaysUntilExpiry,
    subscriptionExpiringBannerDismissed,
    subscriptionEndDate,
    subscriptionExempt,
    subscriptionHasPlan,
    subscriptionCompanyId,
    subscriptionPlanDetails,
    subscriptionQuotaStatus,
    dismissSubscriptionExpiringBanner,
  } = useContext(RefreshContext);
  const dispatch = useDispatch();
  const {
    token: { colorBgLayout, colorPrimary, colorBgContainer },
  } = theme.useToken();

  const [emailNotifications, setEmailNotifications] = useState(false); // for email notification
  const [emailNotificationsAPIcall, setEmailNotificationsAPIcall] = useState(false); // for email notification API call
  const [profilePicture, setProfilePicture] = useState("");
  const [companyLogo,setCompanyLogo]= useState("");

  const steps = [
   
    {
      title: 'Select Group',
      description: 'Please select the group here.',
      target: () => ref1.current,
      mask: {
        style: {
          //boxShadow: 'inset 0 0 15px #fff',
          backdropFilter: 'grayscale(100%)',
        },
        color: 'rgba(0, 0, 0, 0.60)',
      },
    },
    {
      title: 'Select Company',
      description: 'Please select the company here.',
      target: () => ref2.current,
      mask: {
        style: {
          //boxShadow: 'inset 0 0 15px #fff',
          backdropFilter: 'grayscale(100%)',
        },
        color: 'rgba(0, 0, 0, 0.45)',
      },
    },
  ];

  const handleDrawerOpen = () => {
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
  };

  const decodedTokenValue = decodeToken(token) ||{};
  const roleName = decodedTokenValue.role?.name;

  const showHelpIcon = useMemo(() => {
    // groupId state stores the selected group NAME (label), not the Mongo id
    if (!groupId || groupId === 'Select Group') {
      return false;
    }

    // Prefer matching by name from React state (reliable after auto-select).
    // localStorage id is only a fallback — reading it alone can miss the icon
    // when state updates before localStorage is written in the auto-select path.
    const selectedGroup =
      groupsData.find((group) => group.name === groupId) ||
      (() => {
        const selectedGroupId = localStorage.getItem('groupId');
        if (
          !selectedGroupId ||
          selectedGroupId === 'Select Group' ||
          selectedGroupId === '-1'
        ) {
          return null;
        }
        return groupsData.find(
          (group) => String(group._id) === String(selectedGroupId)
        );
      })();

    return selectedGroup?.isSOCreated === true;
  }, [groupsData, groupId]);

  const handleOpenHelp = async () => {
    const userId = decodedTokenValue?.userId;
    const groupIdHeader = localStorage.getItem('groupId');
    const companyIdHeader = localStorage.getItem('companyId');

    if (!token || !userId) {
      message.error('Unable to open help. Please sign in again.');
      return;
    }

    setHelpLoading(true);
    try {
      const res = await UserAPI.getGuideVideosLink(
        token,
        groupIdHeader,
        companyIdHeader
      );
      const redirectUrl = res?.data?.redirect_url;
      if (redirectUrl) {
        window.open(redirectUrl, '_blank', 'noopener,noreferrer');
      } else {
        message.error('Help link is unavailable right now.');
      }
    } catch (err) {
      message.error(
        err?.response?.data?.message || 'Unable to open help right now.'
      );
    } finally {
      setHelpLoading(false);
    }
  };

  const loadSubscriptionForCompany = async (selectedCompanyId) => {
    const isSystemAdmin = roleName === 'System Admin';
    const groupIdHeader = localStorage.getItem('groupId');

    if (
      !selectedCompanyId ||
      selectedCompanyId === 'Select Company' ||
      !groupIdHeader ||
      groupIdHeader === 'Select Group' ||
      groupIdHeader === '-1'
    ) {
      if (isSystemAdmin) {
        setSystemAdminSubscriptionAccess();
      } else {
        clearSubscriptionState();
      }
      return;
    }

    applySubscriptionState({ subscriptionLoading: true });

    try {
      const res = await CompanyAPI.getCompanyById(
        token,
        groupIdHeader,
        selectedCompanyId,
        selectedCompanyId
      );
      const plan = res?.data?.subscriptionPlanDetails;
      const subscriptionExpiredFlag = res?.data?.subscriptionExpired === true;
      const status = getCompanySubscriptionStatus(plan, subscriptionExpiredFlag);
      const isExpired = subscriptionExpiredFlag || status.isExpired;
      applySubscriptionState({
        subscriptionPlanExpired: isExpired,
        subscriptionExpiringSoon: !isSystemAdmin && status.isExpiringSoon,
        subscriptionDaysUntilExpiry: status.daysUntilExpiry,
        subscriptionExpiringBannerDismissed: false,
        subscriptionReadOnly: isSystemAdmin ? false : isExpired,
        subscriptionExempt: isSystemAdmin,
        subscriptionEndDate: status.endDate,
        subscriptionHasPlan: status.hasPlan,
        subscriptionCompanyId: selectedCompanyId,
        subscriptionPlanDetails: plan ?? null,
        subscriptionLoading: false,
        ...(selectedCompanyId !== subscriptionCompanyId
          ? { subscriptionQuotaStatus: null }
          : {}),
      });

      CompanyAPI.getSubscriptionQuotas(
        token,
        groupIdHeader,
        selectedCompanyId,
        selectedCompanyId
      )
        .then((quotaRes) => {
          applySubscriptionState({
            subscriptionQuotaStatus: quotaRes?.data ?? null,
          });
        })
        .catch(() => {
          applySubscriptionState({ subscriptionQuotaStatus: null });
        });
    } catch (err) {
      if (isSystemAdmin) {
        setSystemAdminSubscriptionAccess();
      } else {
        applySubscriptionState({
          subscriptionReadOnly: false,
          subscriptionExempt: false,
          subscriptionPlanExpired: false,
          subscriptionExpiringSoon: false,
          subscriptionDaysUntilExpiry: null,
          subscriptionExpiringBannerDismissed: false,
          subscriptionEndDate: null,
          subscriptionHasPlan: false,
          subscriptionCompanyId: selectedCompanyId,
          subscriptionPlanDetails: null,
          subscriptionQuotaStatus: null,
          subscriptionLoading: false,
        });
      }
    }
  };

  useEffect(() => {
    registerSubscriptionReload(() => {
      const savedCompanyId = localStorage.getItem('companyId');
      if (savedCompanyId && savedCompanyId !== 'Select Company') {
        return loadSubscriptionForCompany(savedCompanyId);
      }
      return undefined;
    });
  }, [registerSubscriptionReload, token, roleName]);

  const shouldPollSubscription = shouldPollSubscriptionState({
    subscriptionExempt,
    subscriptionPlanExpired,
    subscriptionReadOnly,
    subscriptionHasPlan,
    subscriptionCompanyId,
  });

  useSubscriptionQuotaRefresh({
    enabled: shouldPollSubscription,
    onRefresh: refreshSubscriptionState,
  });

  const handleSubscriptionExpiredMidSession = useCallback(() => {
    const isSystemAdmin = roleName === 'System Admin';
    applySubscriptionState({
      subscriptionPlanExpired: true,
      subscriptionExpiringSoon: false,
      subscriptionReadOnly: !isSystemAdmin,
      subscriptionDaysUntilExpiry: 0,
      subscriptionExpiringBannerDismissed: true,
    });
  }, [applySubscriptionState, roleName]);

  const handleSubscriptionAutoLogout = useCallback(() => {
    clearSubscriptionState();
    dispatch(logout());
    navigate('/login');
  }, [clearSubscriptionState, dispatch, navigate]);

  const { showLogoutModal, logoutSecondsRemaining } = useSubscriptionExpiryWatcher({
    endDate: subscriptionEndDate,
    companyId: subscriptionCompanyId,
    groupId: localStorage.getItem('groupId'),
    token,
    hasPlan: subscriptionHasPlan,
    isExempt: subscriptionExempt,
    subscriptionActive: !subscriptionPlanExpired,
    onSubscriptionExpired: handleSubscriptionExpiredMidSession,
    onAutoLogout: handleSubscriptionAutoLogout,
  });

  const performLogout = useCallback(() => {
    clearSubscriptionState();
    dispatch(logout());
    navigate('/login');
  }, [clearSubscriptionState, dispatch, navigate]);

  const confirmLogout = useCallback(() => {
    setLogoutConfirmOpen(true);
  }, []);

  const handleLogoutCancel = useCallback(() => {
    setLogoutConfirmOpen(false);
  }, []);

  const handleLogoutConfirm = useCallback(() => {
    setLogoutConfirmOpen(false);
    performLogout();
  }, [performLogout]);

  const handleOpenManageProfile = async () => {
    if (!token) {
      message.error('Unable to open manage profile. Please sign in again.');
      return;
    }

    setManageProfileLoading(true);
    try {
      await openManageProfileLink(token);
    } finally {
      setManageProfileLoading(false);
    }
  };

  const handleMenuClick = (e) => {
    if (e.key === 'settings') {
      navigate('/profile');
    } else if (e.key === 'so-portal') {
      handleOpenManageProfile();
    } else if (e.key === 'company') {
      navigate('/company-profile'); // Navigate to Company Profile
    } else if (e.key === 'feature-news') {
      setFeatureNewsAdminOpen(true);
    } else if (e.key === 'faq') {
      setFaqAdminOpen(true);
    } else if (e.key === 'logout') {
      confirmLogout();
    }
  };

  const onEmailNotoficationChange = (checked)=>
  {
    setEmailNotifications(checked);
    //call the API for apply the change
     setEmailNotificationMessage(checked);
    //setEmailNotificationsAPIcall(true);

  }
  const showSoPortalInMenu = shouldShowSelfOnboardingPortalLink(
    roleName,
    subscriptionPlanDetails,
    token
  );

  const settingsMenuItems = [
    {
      key: 'menu-title',
      label: 'Settings',
      disabled: true,
      style: { cursor: 'default', fontWeight: 'bold', fontSize: '16px', padding: '10px 15px' },
    },
    { type: 'divider' },
    {
      key: 'email-notifications',
      label: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <span style={{ flexGrow: 1, textAlign: 'left', marginRight: '15px' }}>
            Email Notifications
          </span>
          <Switch
            checked={emailNotifications === true}
            onChange={onEmailNotoficationChange}
          />
        </div>
      ),
    },
    { type: 'divider' },
    {
      key: 'settings',
      icon: manageProfileLoading ? <LoadingOutlined /> : <UserOutlined />,
      disabled: manageProfileLoading,
      label: 'Manage Profile',
    },
    ...(showSoPortalInMenu
      ? [{
          key: 'so-portal',
          icon: manageProfileLoading ? <LoadingOutlined /> : <ExportOutlined />,
          disabled: manageProfileLoading,
          label: 'Manage Subscription',
        }]
      : []),
    {
      key: 'company',
      icon: <BankOutlined />,
      disabled: roleName != "Company Admin",
      label: 'Company Profile',
    },
    ...(roleName === 'System Admin' && isFeatureNewsEnabled()
      ? [{
          key: 'feature-news',
          icon: <BellOutlined />,
          label: 'Feature news',
        }]
      : []),
    ...(roleName === 'System Admin' && isFaqEnabled()
      ? [{
          key: 'faq',
          icon: <ReadOutlined />,
          label: 'FAQ',
        }]
      : []),
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
    },
  ];

  //console.log("Menu Item Mapping");
  // console.log(menu);
  /*Object.values(menu).forEach(function (value) {
    // do something with data[key]
    console.log(value);
  });*/

  useEffect(() => {
    setEmailNotifications(decodedTokenValue.isEmailNotification === true);
  }, [token]);

  useEffect(() => {
    getAllGroups();
    const decoded = decodeToken(token);
    if (decoded?.userId) {
      getProfilePicture(decoded.userId);
    }
  }, [refreshKey, roleName]);

  useEffect(() => {
    const savedCompanyId = localStorage.getItem('companyId');
    if (savedCompanyId && savedCompanyId !== 'Select Company' && isDataLoaded) {
      loadSubscriptionForCompany(savedCompanyId);
    } else if (roleName === 'System Admin') {
      setSystemAdminSubscriptionAccess();
    }
  }, [refreshKey, isDataLoaded, roleName]);

  useEffect(() => {
    getCompanyProfilePicture();
  }, [refreshKey]);

  useEffect(() => {
    const decodedTokenValue = decodeToken(token);
    setSelectedRole(decodedTokenValue.role.name);
    const role = decodedTokenValue.role.name;

    setMenuItems([]);
    let listPayload = [
      getItem('Dashboard', '/dashboard', <HomeOutlined />),
    ];

    let businessEntityDataList = [];
    let administrationDataList = [];
    let templatesDataList = [];
    let masterDataDataList = [];
    let documentManagementDataList = [];
    let reportsDataList = [];

    const addItem = (list, item) => {
      if (!list.some(existingItem => existingItem.key === item.key)) {
        list.push(item);
      }
    };
    const canAccessMasterData =
      subscriptionExempt ||
      isSubscriptionPlanFeatureEnabled(
        subscriptionPlanDetails,
        SUBSCRIPTION_FEATURE_KEYS.masterDataHandling
      );
    const masterDataDisabled = !canAccessMasterData;

    const addMasterDataMenuItem = (list) => {
      addItem(
        list,
        getItem(
          getDisabledTooltipLabel(
            'Trading Partners',
            masterDataDisabled,
            SUBSCRIPTION_MASTER_DATA_DISABLED_HINT,
            'Master Data unavailable'
          ),
          '/masterdata/tradingpartners',
          null,
          undefined,
          undefined,
          masterDataDisabled
        )
      );
    };

    //console.log(role);
    if (role !== null) {
      if (role === "System Admin") {
        addItem(businessEntityDataList, getItem('Groups', '/businessentity/Groups'));
        addItem(businessEntityDataList, getItem('Companies', '/businessentity/Company'));
        addItem(administrationDataList, getItem('Users', '/administration/Users'));
        addItem(templatesDataList, getItem('Templates', '/templates/templates'));
        addMasterDataMenuItem(masterDataDataList);
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Document Summary Report', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      } else if (role === "Group Admin") {
        addItem(businessEntityDataList, getItem('Companies', '/businessentity/Company'));
        addItem(administrationDataList, getItem('Users', '/administration/Users'));
        addItem(templatesDataList, getItem('Templates', '/templates/templates',)); //According to priority List No:- 9
        addMasterDataMenuItem(masterDataDataList);
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Reports', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      } else if (role === "Company Admin") {
        addItem(businessEntityDataList, getItem('Companies', '/businessentity/Company'));
        addItem(administrationDataList, getItem('Users', '/administration/Users'));
        addItem(templatesDataList, getItem('Templates', '/templates/templates')); //According to priority List No:- 9
        addMasterDataMenuItem(masterDataDataList);
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Reports', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      } else if (role === "General User") {
        addItem(templatesDataList, getItem('Templates', '/templates/templates'));// According to priority List No:- 9
        addMasterDataMenuItem(masterDataDataList);
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Reports', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      }
    }

    if (businessEntityDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Business Entity', '', <AppstoreOutlined />, businessEntityDataList),
      );
    }

    if (administrationDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Administration', '/administration', <SettingOutlined />, administrationDataList),
      );
    }

    if (templatesDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Templates', '/templates', <SettingOutlined />, templatesDataList,'', checkGroupAndCompanyValues()),
      );
    }

    if (masterDataDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem(
          getDisabledTooltipLabel(
            'Master Data',
            masterDataDisabled,
            SUBSCRIPTION_MASTER_DATA_DISABLED_HINT,
            'Master Data unavailable'
          ),
          '11',
          <AppstoreOutlined />,
          masterDataDataList,
          undefined,
          masterDataDisabled
        ),
      );
    }

    if (documentManagementDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Document Management', '/documentupload', <FileWordOutlined />, documentManagementDataList,'',checkGroupAndCompanyValues()),
      );
    }

    if (reportsDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Reports', '/reports', <CalendarOutlined />, reportsDataList,'',checkGroupAndCompanyValues()),
      );
    }

    listPayload.push(
      getItem('Contact Us', '/contact', <MessageOutlined />),
    );

    setMenuItems(listPayload);
  }, [selectedRole, groupId, companyId, subscriptionPlanDetails, subscriptionExempt]);

  const getAllGroups = async () => {
    await AuthRestAPI.getAllGroups(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
      if (res?.data) {
        //console.log(JSON.stringify(res.data));
        //alert(JSON.stringify(res.data));
        const items = [];
        const loggedRole = decodeToken(token)?.role?.name;
        if (loggedRole !== "Group Admin") {
          items.push({
            value: "-1",
            label: "All Groups",
          });
        }
        [...res.data]
          .sort((a, b) =>
            String(a.name || '').localeCompare(String(b.name || ''), undefined, {
              sensitivity: 'base',
            })
          )
          .forEach((rowValue) => {
            items.push({
              value: rowValue._id,
              label: rowValue.name,
            });
          });
        setGroups(items);
        setGroupsData(res.data);

        // If there's a saved groupId, load companies for that group
        const savedGroupId = localStorage.getItem('groupId');
        const savedGroup =
          savedGroupId &&
          savedGroupId !== "Select Group" &&
          savedGroupId !== "-1"
            ? res.data.find((group) => group._id === savedGroupId)
            : null;

        if (savedGroup) {
          setGroupId(savedGroup.name);
          persistAllowCompanyCreationForGroup(savedGroup);
          getAllCompany(savedGroupId);
        } else if (res.data.length === 1) {
          // Auto-select when the user belongs to only one group
          const singleGroup = res.data[0];
          localStorage.setItem('groupId', singleGroup._id);
          setGroupId(singleGroup.name);
          persistAllowCompanyCreationForGroup(singleGroup);
          getAllCompany(singleGroup._id);
        } else {
          localStorage.removeItem('allowCompanyCreation');
          setIsDataLoaded(true);
        }
      }
    }).catch(err => {
      setIsDataLoaded(true);
    })
  };

  const getProfilePicture = async (userId) => {
    await UserAPI.getProfilePicture(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), userId).then((res) => {
      if (res?.data) {
        //console.log(JSON.stringify(res.data.profilePicture)); 
        setProfilePicture(res.data.profilePicture);
      }
    }).catch(err => {
    })
  };

  const getCompanyProfilePicture = async () => {
    if(localStorage.getItem('companyId')!==null && localStorage.getItem('companyId')!==undefined && localStorage.getItem('companyId')!=="")
    { //setCompanyLogo
        await CompanyAPI.getMyCompany(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
          if (res?.data.companyLogo.split("/").pop() !== "undefined" && res?.data.companyLogo.split("/").pop() !== null ) {
            setCompanyLogo(res.data.companyLogo); 
          }
          else{
            setCompanyLogo();
          }
      }).catch(err => {
      })
    };
  }
  const onGroupSelect = (value) => {
    if (value !== null) {
      setCompanys([]);
      getAllCompany(value);

      const selectedGroup = groups.find(group => group.value === value);
      if (selectedGroup) {
        setGroupId(selectedGroup.label);
      }

      setCompanyId("Select Company");
      clearSubscriptionState();
      localStorage.removeItem('groupId');
      localStorage.removeItem('companyId');
      localStorage.removeItem('allowCompanyCreation');
      localStorage.setItem('groupId', value);

      if (value === "-1") {
        localStorage.removeItem('allowCompanyCreation');
      } else {
        const selectedGroupData = groupsData.find((group) => group._id === value);
        persistAllowCompanyCreationForGroup(selectedGroupData);
      }
    }
  }

  const getAllCompany = async (selectedGroupId) => {
    await AuthRestAPI.getAllCompanys(token, selectedGroupId, localStorage.getItem('companyId')).then((res) => {
      if (res?.data) {
        //console.log(JSON.stringify(res.data));
        //alert(JSON.stringify(res.data));
        const items = [];
        [...res.data]
          .sort((a, b) =>
            String(a.name || '').localeCompare(String(b.name || ''), undefined, {
              sensitivity: 'base',
            })
          )
          .forEach((rowValue) => {
            items.push({
              value: rowValue._id,
              label: rowValue.name,
            });
          });
        setCompanys(items);
        
        // If there's a saved companyId and it's not "Select Company", ensure it's set
        const savedCompanyId = localStorage.getItem('companyId');
        const savedCompany =
          savedCompanyId && savedCompanyId !== "Select Company"
            ? res.data.find((company) => company._id === savedCompanyId)
            : null;

        if (savedCompany) {
          setCompanyId(savedCompany.name);
          loadSubscriptionForCompany(savedCompanyId);
        } else if (res.data.length === 1) {
          // Auto-select when the user belongs to only one company in this group
          const singleCompany = res.data[0];
          setCompanyId(singleCompany.name);
          localStorage.setItem('companyId', singleCompany._id);
          loadSubscriptionForCompany(singleCompany._id);
        }
        setIsDataLoaded(true);
      }
    }).catch(err => {
      setIsDataLoaded(true);
    })
  };

    const setEmailNotificationMessage = async (checked) => {
    const emailObject = { isEmailNotification:checked }
 
    await UserAPI.setEmailNotificationMessage(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), emailObject)
    .then((res) => {
      if (res?.data) {
 
       //setEmailNotifications(res.data.isEmailNotification);
      }
    }).catch(err => {
      setEmailNotifications(false);
    })
  };

  const onCompanySelect = (value) => {
    if (value !== null) {
      const selectedCompany = companys.find(company => company.value === value);
      if (selectedCompany) {
        setCompanyId(selectedCompany.label);
      }
      localStorage.removeItem('companyId');
      localStorage.setItem('companyId', value);
      loadSubscriptionForCompany(value);
    }
  }

  const checkGroupAndCompanyValues = () =>
  {
    let status = true;
    if (groupId !== null && groupId !== undefined && groupId !== 'Select Group') {
       status = false;
    }
    if (companyId !== null && companyId !== undefined && companyId !== 'Select Company') {
      status = false;
    }
    else
    {
      status = true;
    }
    return status;
  }

  return (
    <>
    <Layout style={{ minHeight: 'calc(100% - 128px)' }}>
      <Header
        style={{
          backgroundColor: colorBgLayout,
          paddingTop: '15px',
          paddingBottom: '15px',
          height: '90px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Flex align="center" justify="flex-start" gap={24} >
          <Title level={1} className="logotext">
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img style={{ width: 32, marginTop: -15 }} src={Logo} alt="Logo" /> mogu
            </span>
          </Title>
          <div className='desktop'>
            <ContextSelector
              groupRef={ref1}
              companyRef={ref2}
              groupValue={groupId}
              companyValue={companyId}
              groups={groups}
              companys={companys}
              isDataLoaded={isDataLoaded}
              onGroupSelect={onGroupSelect}
              onCompanySelect={onCompanySelect}
              variant="inline"
              showSelectionTips={!drawerVisible}
            />
            {companyLogo ? (
              <img
                src={companyLogo}
                alt="Company logo"
                className="context-selector-company-logo"
              />
            ) : null}
          </div>
        </Flex>
        <div key={refreshKey}>{children}</div>
        <Flex align="center" gap={16}>
          <Flex align="center" gap={14} className="header-utility-icons">
            <button
              type="button"
              className="header-icon-button"
              onClick={toggleTheme}
              aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
              style={{ color: isDarkMode ? '#ffd700' : '#555' }}
            >
              {isDarkMode ? <SunOutlined /> : <MoonOutlined />}
            </button>
            {isFaqEnabled() ? (
              <button
                type="button"
                className="header-icon-button faq-header-button"
                onClick={() => setFaqDrawerOpen(true)}
                aria-label="FAQ"
                title="FAQ"
                style={{ color: isDarkMode ? '#ffd700' : '#555' }}
              >
                <ReadOutlined />
                <span>FAQ</span>
              </button>
            ) : null}
            {showHelpIcon ? (
              <button
                type="button"
                className="header-icon-button"
                onClick={handleOpenHelp}
                disabled={helpLoading}
                aria-label="Help"
                title="Help"
                style={{ color: isDarkMode ? '#ffd700' : '#555' }}
              >
                {helpLoading ? <LoadingOutlined spin /> : <QuestionCircleOutlined />}
              </button>
            ) : null}
          </Flex>
          {/*<span style={{ marginTop: '7px' }}> remove the notification icon
            <Badge count={'5'} offset={[-15, 0]}>
              <BellOutlined style={{ fontSize: '25px', color: isDarkMode ? '#ffd700' : '#555', cursor: 'pointer', marginRight: '10px' }} />
            </Badge>
          </span>*/}
          <Dropdown menu={{ items: settingsMenuItems, onClick: handleMenuClick }} trigger={['click']} placement="bottomRight">
            <Avatar onClick={(e) => e.preventDefault()}
              style={{ cursor: 'pointer', backgroundColor: colorPrimary, marginTop: '-10px' }}
              //icon={<UserOutlined />} 
              src={profilePicture}
              size="large"
            />
          </Dropdown>
          <span >
            {/* Drawer Menu Toggle */}
            <Button
              className="drawer-toggle"
              type="text"
              icon={<MenuOutlined />}
              style={{ fontSize: 24,marginTop:'-25px' }}
              onClick={handleDrawerOpen}
            />
          </span>
        </Flex>
      </Header>

      {/* Drawer for Mobile Navigation */}
      <Drawer
        title="Menu"
        placement="left"
        onClose={handleDrawerClose}
        open={drawerVisible}
        styles={{ body: { padding: 0 } }}
      >

        {/* Add the Company Dropdown and Logo to the Drawer */}
        <Flex vertical gap={16} style={{ padding: '16px' }}>
          <img src={CompanyLogo} alt="Company Logo" style={{ height: '30px', width: 'fit-content', marginBottom: 8 }} />
          <ContextSelector
            groupRef={ref1}
            companyRef={ref2}
            groupValue={groupId}
            companyValue={companyId}
            groups={groups}
            companys={companys}
            isDataLoaded={isDataLoaded}
            onGroupSelect={onGroupSelect}
            onCompanySelect={onCompanySelect}
            variant="stacked"
            showSelectionTips={drawerVisible}
          />
        </Flex>
        <Menu
          mode="inline"

          items={menuItems}
          onClick={({ key }) => {
            navigate(key);
            handleDrawerClose();
          }}
        />
      </Drawer>

      <Header style={{ backgroundColor: colorBgLayout, display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 16 }} className='main-menu'>
        <Menu
          mode="horizontal"
          items={menuItems}
          style={{ flex: 1, justifyContent: 'center', borderRadius: 64 }}
          onClick={({ key }) => navigate(key)}
        />
      </Header>

      <Content style={{ backgroundColor: colorBgLayout, paddingLeft: '52px', paddingRight: '52px', minHeight: '85svh' }}>
        {subscriptionPlanExpired && (
          <SubscriptionExpiredBanner
            endDate={subscriptionEndDate}
            isDarkMode={isDarkMode}
            unrestrictedAccess={subscriptionExempt}
            roleName={roleName}
            subscriptionPlanDetails={subscriptionPlanDetails}
          />
        )}
        {!subscriptionPlanExpired &&
          subscriptionExpiringSoon &&
          !subscriptionExempt &&
          !subscriptionExpiringBannerDismissed && (
          <SubscriptionExpiringSoonBanner
            endDate={subscriptionEndDate}
            isDarkMode={isDarkMode}
            onClose={dismissSubscriptionExpiringBanner}
            roleName={roleName}
            subscriptionPlanDetails={subscriptionPlanDetails}
          />
        )}
        {isDataLoaded ? (
          <>
            <Suspense
              fallback={
                <div
                  style={{ display: 'flex', justifyContent: 'center', padding: '80px 0' }}
                  aria-busy="true"
                  aria-label="Loading"
                >
                  <Spin size="large" />
                </div>
              }
            >
              <Outlet context={{
                isDarkMode,
                groupId,
                companyId,
                subscriptionReadOnly: subscriptionReadOnly && !subscriptionExempt,
                subscriptionPlanExpired,
                subscriptionExpiringSoon: subscriptionExpiringSoon && !subscriptionExempt,
                subscriptionDaysUntilExpiry,
                subscriptionEndDate,
                subscriptionPlanDetails,
                subscriptionQuotaStatus,
                subscriptionExempt,
              }} />
            </Suspense>
            <FeatureNewsHost userId={decodedTokenValue?.userId || authUserId} token={token} />
          </>
        ) : (
          <div
            style={{ display: 'flex', justifyContent: 'center', padding: '80px 0' }}
            aria-busy="true"
            aria-label="Loading"
          >
            <Spin size="large" />
          </div>
        )}
        <center style={{ paddingTop: 24, paddingBottom: 24 }}>
          ©{new Date().getFullYear()} metora. All rights reserved.
        </center>
      </Content>
      <Tour
    open={open}
    onClose={() => setOpen(false)}
    steps={steps}
    gap={{
      radius,
    }}
    // mask={{
    //   style: {
    //     boxShadow: 'inset 0 0 15px #333',
    //     filter:' blur(8px)',
    //   },
    //   color: 'rgba(80, 255, 255, .4)',
    // }}
  />
    </Layout>

    <SubscriptionExpiredLogoutModal
      open={showLogoutModal}
      secondsRemaining={logoutSecondsRemaining}
    />

    <LogoutConfirmModal
      open={logoutConfirmOpen}
      onCancel={handleLogoutCancel}
      onConfirm={handleLogoutConfirm}
      isDarkMode={isDarkMode}
    />
    <FeatureNewsAdminModal
      open={featureNewsAdminOpen}
      onClose={() => setFeatureNewsAdminOpen(false)}
      token={token}
    />
    <FaqAdminModal
      open={faqAdminOpen}
      onClose={() => setFaqAdminOpen(false)}
      token={token}
    />
    <FaqDrawer
      open={faqDrawerOpen}
      onClose={() => setFaqDrawerOpen(false)}
      token={token}
      isDarkMode={isDarkMode}
    />
   
  </>
  );
}
